import PageTitle from "../../components/PageTitle/PageTitle";
import Button from "../../components/Button/Button";
import Table from "../../components/Table/Table";
import { TableSearch } from "../../components/Table/TableActions";
import useWindowSize from "../../hooks/useWindow";
import { useState, useEffect } from "react";
import { httprequest } from "../../data/api";
import { Icon } from "@iconify/react/dist/iconify.js";
import { ToastContainer, toast } from "react-toastify";
import PageLoader from "../../components/PageLoader/pageloader";
import Modal from "../../components/Modal";
import Badge from "../../components/Badge/Badge";
import { useNavigate } from "react-router-dom";
import SelectGroup from "../../components/FormComponent/SelectGroup";

const SUPPORT_ENDPOINT = "/admin/v1/ticket-notifications";
const DELETE_SUPPORT_ENDPOINT = "/admin/v1/delete/ticket";

const Support = () => {
  const navigate = useNavigate();
  const [currentRow, setCurrentRow] = useState({});
  const [supporttickets, setSupportTickets] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [filterPriority, setFilterPriority] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setisDeleting] = useState(false);
  const width = useWindowSize();
  const mobile = width < 600;

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleGetAllTickets = () => {
    setIsLoading(true);
    httprequest
      .get(SUPPORT_ENDPOINT)
      .then((res) => {
        setIsLoading(false);
        setFilterStatus("");
        setFilterPriority("");
        setSupportTickets(res?.data?.data?.ticket_notifications);
        setSearchResult(res?.data?.data?.ticket_notifications);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  // Delete Admin Ticket
  const handleDeleteTicket = () => {
    setisDeleting(true);
    httprequest
      .delete(`${DELETE_SUPPORT_ENDPOINT}/${currentRow?.id}`)
      .then((res) => {
        setisDeleting(false);
        toast.success(res?.data?.message);
        handleCloseDeleteModal();
        handleGetAllTickets();
      })
      .catch((err) => {
        setisDeleting(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    // Update state first and use the updated values inside a useEffect
    if (name === "status") {
      setFilterStatus(value);
    } else if (name === "priority") {
      setFilterPriority(value);
    }
  };

  // Use useEffect to run filtering logic again whenever status or priority changes
  useEffect(() => {
    const filteredResults = supporttickets?.filter((data) => {
      const statusMatch = filterStatus ? data?.status === filterStatus : true;
      const priorityMatch = filterPriority ? data?.priority === filterPriority : true;

      return statusMatch && priorityMatch;
    });

    setSearchResult(filteredResults);
  }, [filterStatus, filterPriority, supporttickets]);

  useEffect(() => {
    handleGetAllTickets();
  }, []);

  const columns = [
    {
      name: "Ticket ID",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Title</p>}
          {row?.ticket_id || "--/--"}
        </>
      )
    },
    {
      name: "Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Name</p>}
          {`${row?.first_name} ${row?.last_name}` || "--/--"}
        </>
      )
    },
    {
      name: "E-mail",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Email</p>}
          {row?.email || "--/--"}
        </>
      )
    },
    {
      name: "Subject",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Added By</p>}
          {row?.subject || "--/--"}
        </>
      )
    },
    {
      name: "Priority",
      center: "true",
      cell: (row) => <Badge status={row?.priority} />
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Status</p>}
          {row?.status}
        </>
      ),
      center: "true"
    },
    {
      name: "Date Created",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Created</p>}
          {row?.created_at?.substring(0, 10)}
        </>
      ),
      center: "true"
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => navigate(`/support/ticket/${row?.ticket_notification_id}?support_ticket_id=${row?.support_ticket_id}`)}>
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button
            className="table-action-icon delete-icon"
            onClick={() => handleDeleteModal(row)}
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  // --| Filter Ticket table using title, subject, priority who can access
  const handleSearchSupport = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // Filter by status (if selected)
    const filteredByStatus = filterStatus
      ? supporttickets.filter((data) => data.status.toLowerCase() === filterStatus.toLowerCase())
      : supporttickets;

    // Filter by priority (if selected)
    const filteredByPriority = filterPriority
      ? filteredByStatus.filter((data) => data.priority.toLowerCase() === filterPriority.toLowerCase())
      : filteredByStatus;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByPriority?.filter((data) => valArray?.every(
      (word) => data?.status?.toLowerCase().includes(word.toLowerCase()) ||
            data?.subject?.toLowerCase().includes(word.toLowerCase()) ||
            data?.ticket_id?.toLowerCase().includes(word.toLowerCase()) ||
            data?.priority?.toLowerCase().includes(word.toLowerCase()) ||
            data?.email?.toLowerCase().includes(word.toLowerCase()) ||
            data?.department?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <>
      <PageTitle
        title="Tickets"
        subtitle="See all your tickets here"
        // button={
        //   <div className="flex gap-10 button_tab">
        //     <Button
        //       variant="primary"
        //       buttonSize="fluid"
        //       color="btndefault"
        //       onClick={() => navigate("/support/open-ticket")}
        //       buttonName="Create a Ticket"
        //     />
        //   </div>
        // }
      />
      <div className="page-content">
        {isLoading ? (
          <PageLoader />
        ) : (
          <Table
            data={searchResult}
            columns={columns}
            subHeader={true}
            pagination
            subHeaderComponent={
              <div className="action_div flex-wrap-items-426">
                <TableSearch
                  placeholder="Search here..."
                  searchTableFunc={handleSearchSupport}
                />
                <div className="text-center gap-10">
                  {isLoading ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                    : <Icon onClick={handleGetAllTickets} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} className="cursor-pointer" />}
                  <div className="text-center gap-10">
                    <div>
                      <SelectGroup
                        children={
                          <select name="status" onChange={handleFilterChange}>
                            <option value="">-- Sort By Status--</option>
                            <option value="open">Open</option>
                            <option value="closed">Closed</option>
                          </select>
                        }
                      />
                    </div>
                    <div>
                      <SelectGroup
                        children={
                          <select name="priority" onChange={handleFilterChange}>
                            <option value="">-- Sort By Priority--</option>
                            <option value="high">High</option>
                            <option value="medium">Medium</option>
                            <option value="low">Low</option>
                          </select>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        )}
      </div>
      {/* Delete Modal */}
      <Modal
        title="Delete A Ticket"
        subtitle={
          <div>
                Are you sure you want to remove TICKET{" "}
            <span className="modal-name-highlight">
              {currentRow?.ticket_id}
            </span>
                . from one of your Tickets? Removing it will permanently
                delete this Tioket.`
          </div>
        }
        modalContent={<></>}
        modalFooter={
          <>
            <div className="flex gap-10">
              <Button
                variant="dangeroutline"
                buttonSize="full"
                color="btndanger"
                buttonName="Cancel"
                onClick={handleCloseDeleteModal}
              />
              <Button
                variant="danger"
                buttonName="Delete Ticket"
                buttonSize="full"
                color="btndefault"
                onClick={handleDeleteTicket}
                isLoading={isDeleting}
              />
            </div>
          </>
        }
        isopen={deleteModal}
        closeModal={handleCloseDeleteModal}
      />
      <ToastContainer />
    </>
  );
};

export default Support;
